const lg = {
  "nav.home": "Awaka",
  "nav.services": "Emirimu",
  "nav.services.website": "Okukola Website",
  "nav.services.smm": "Obwatangaaza ku Social Media",
  "nav.services.traffic": "Ebikwaata ku Dijitali",
  "nav.aiTools": "Ebikozesebwa bya AI",
  "nav.aiTools.reviews": "Okukyusa Ebikozesebwa bya AI",
  "nav.aiTools.guides": "Amagezi n\'Emyoyo",
  "nav.aiTools.landing": "Emiko / Obuwa",
  "nav.about": "Ebikuusa",
  "nav.profile": "Ebifanany",
  "nav.contact": "Kugatta",
  "nav.getStarted": "Tandika",
  "nav.language": "Olulimi",

  "hero.eyebrow": "Ekibiina Ekisinga mu Uganda",
  "hero.title1": "Kyusa Ebikolwa Byo",
  "hero.title2": "mu Dijitali",
  "hero.title3": "Ne BientoMart",
  "hero.subtitle": "Tukola websites, tutumbula social media, era tukuganirira ebikozesebwa bya AI ebirungi okubudaabuda omuwendo gw\'omulimu gwo.",
  "hero.cta1": "Laba Emirimu",
  "hero.cta2": "Laba Ebikozesebwa bya AI",
  "hero.stat1.value": "30+",
  "hero.stat1.label": "Emirimu Egyazikirizibwa",
  "hero.stat2.value": "98%",
  "hero.stat2.label": "Abagagga Basanyufu",
  "hero.stat3.value": "24/7",
  "hero.stat3.label": "Obuyambi Buli kiseera",

  "services.label": "Emirimu Gyaffe",
  "services.title": "Byonna Ebyetaagibwa Okuzimba Omuwendo Gwo",
  "services.subtitle": "Okuva mu websites ez\'amaani okutuuka ku strategies ez\'amaani za social media, tuwa ebivvuunuka ebiragika.",
  "services.learnMore": "Tegeera Bingi",
  "services.websiteTitle": "Okukola Website",
  "services.websiteDesc": "Websites ezikolerekejebwa omulimu, ez\'okufiirira SEO, ezikola abakwaata abalipya.",
  "services.websiteFeature1": "Design eyetuufu era esobola",
  "services.websiteFeature2": "SEO okuva kumataala",
  "services.websiteFeature3": "Okuzimbuka mangu era kwa nfuufu",
  "services.websiteFeature4": "Ekkola ly\'obuyambi bw\'ebintu",
  "services.websiteFrom": "Okuva ku $299",
  "services.smmTitle": "Obwatangaaza ku Social Media",
  "services.smmDesc": "Obuyambi bw\'obwatangaaza bwa social media obukuza brand yo era obukuza abantu.",
  "services.smmFeature1": "Okukola no okusindika ebintu",
  "services.smmFeature2": "Strategy yo okwegatta n\'abantu",
  "services.smmFeature3": "Analytics n\'Ebibuuzo bya buli mwezi",
  "services.smmFeature4": "Okukozesa Ads",
  "services.smmFrom": "Okuva ku $150/mwezi",
  "services.trafficTitle": "Ebikwaata ku Traffic & Dijitali",
  "services.trafficDesc": "Enkungaana ezikola abantu ab\'omulimu okujja era okuzimba omuwendo gwo.",
  "services.trafficFeature1": "Enkungaana za Google Ads",
  "services.trafficFeature2": "Facebook ne Instagram Ads",
  "services.trafficFeature3": "SEO n\'ebigambo by\'okunoonyereza",
  "services.trafficFeature4": "Okukuza okufiirira",
  "services.trafficFrom": "Okuva ku $200/mwezi",

  "aiTools.label": "Ekifo ky\'Ebikozesebwa bya AI",
  "aiTools.title": "Noonyereza Ebikozesebwa bya AI Ebimaanyi",
  "aiTools.subtitle": "Endagiriro ne reviews ez\'amazima okukuza omulimu gwo.",
  "aiTools.readReview": "Soma Review Yonna",
  "aiTools.rating": "Obukakafu",
  "aiTools.tryNow": "Gezaako Kaakano",
  "aiTools.textGenTitle": "Ekikozesebwa Ekisinga ky\'Ebigambo bya AI",
  "aiTools.textGenCategory": "Okukola Ebintu",
  "aiTools.textGenDesc": "Kola ebibuuzo, okwandika, n\'ebintu by\'obwatangaaza mu kasikati.",
  "aiTools.imageGenTitle": "Ekikozesebwa Eky\'Ebifaananyi bya AI",
  "aiTools.imageGenCategory": "Design",
  "aiTools.imageGenDesc": "Kola ebifaananyi ebirungi, ebifaananyi by\'ebintu, n\'ebifaananyi by\'obwatangaaza.",
  "aiTools.videoCreatorTitle": "Ekikozesebwa ky\'Amafilamu ga AI",
  "aiTools.videoCreatorCategory": "Okukola Amafilamu",
  "aiTools.videoCreatorDesc": "Kyusa emikono gyo mu amafilamu ag\'obusuubuzi mu dakika.",

  "about.label": "Ebikuusa ne BientoMart",
  "about.title": "Mukama Wo ow\'Okunzijukira mu Uganda",
  "about.p1": "BientoMart ye platform eyeyongera mu Uganda ey\'obuyambi bw\'omuwendo, eyayamba abasuubuzi n\'abalimi okuzimba emikono gyamazima ku intaneti okuva mu 2020.",
  "about.p2": "Ekibiina kyaffe ky\'abakozi ab\'amagezi, abaatangaaza, n\'abakozi ba AI kikola obuyambi oburungi eri abagagga mu Afirika y\'Obu Bogero.",
  "about.p3": "Tugatta teknoloji ey\'amaanyi n\'obutegeevu bw\'olusuku lw\'eby\'omu Uganda okukola strategies ezisobola abagagga ba Uganda.",
  "about.stat1.value": "5+",
  "about.stat1.label": "Emyaka mu Bukolwa",
  "about.stat2.value": "50+",
  "about.stat2.label": "Abagagga Basanyufu",
  "about.stat3.value": "30+",
  "about.stat3.label": "Emirimu Egyazikirizibwa",
  "about.cta": "Tukolere Kaakano",

  "testimonials.label": "Ebisuubizo by\'Abagagga",
  "testimonials.title": "Abagagga Baffe Boogera Batya",
  "testimonials.subtitle": "Ebivvuunuka eby\'amazima okuva ku basuubuzi ba Uganda",

  "contact.label": "Kugatta",
  "contact.title": "Tandika Olugendo Lwo lw\'omuwendo mu Dijitali",
  "contact.subtitle": "Olowooza kutandika omuwendo gwo ku ntaneti? Tuganire ebikuusa ng\'BientoMart ekuyamba otyo.",
  "contact.name": "Erinnya Lyo Lyonna",
  "contact.email": "Endagiriro y\'Imeyili",
  "contact.phone": "Ennamba y\'Simu",
  "contact.service": "Omuwendo Gwe Ogenda",
  "contact.message": "Obubaka Bwo",
  "contact.send": "Tuma Obubaka",
  "contact.sending": "Kutuma...",
  "contact.success": "Weebale! Obubaka bwo butuuse. Tujakuddamu mu saawa 24.",
  "contact.error": "Wabaddewo ekizibu. Gezaako nate.",
  "contact.address": "Kampala, Uganda",
  "contact.phoneValue": "+256 773515447",
  "contact.emailValue": "bientomart@gmail.com",
  "contact.hours": "Bbal. - Kya.: 8:00 AM - 6:00 PM EAT",
  "contact.optWebsite": "Okukola Website",
  "contact.optSMM": "Obwatangaaza ku Social Media",
  "contact.optTraffic": "Ebikwaata ku Traffic",
  "contact.optAI": "Ebyobuyigirize bya AI",
  "contact.optOther": "Ebirala",

  "footer.tagline": "Okukuza abasuubuzi ba Uganda okuyita mu dijitali n\'ebikozesebwa bya AI.",
  "footer.services": "Emirimu",
  "footer.resources": "Ebijjukizo",
  "footer.newsletter": "Weewalewo",
  "footer.newsletterDesc": "Nkuwa amagezi g\'obwatangaaza bwa dijitali n\'ebimu ku bikozesebwa bya AI.",
  "footer.emailPlaceholder": "Endagiriro yo y\'Imeyili",
  "footer.subscribe": "Weewalewo",
  "footer.copyright": "© 2026 BientoMart. Eddembe lyonna liggwa.",
  "footer.privacy": "Empisa y\'Obwama",
  "footer.terms": "Ebiragiro by\'Okukozesa",
  "footer.blog": "Blogi",
  "footer.caseStudies": "Ensomo z\'Ebikolwa",
  "footer.tutorials": "Emyoyo",
  "footer.faq": "Ebibuuzo Ebitera Okubuzibwa",
  "footer.websiteCreation": "Okukola Website",
  "footer.smm": "Obwatangaaza ku Social Media",
  "footer.traffic": "Ebikwaata ku Traffic",
  "footer.aiReviews": "Okukyusa Ebikozesebwa bya AI",

  "svc.hiresTitle": "Tukolere Omuwendo Guno",
  "svc.hiresSubtitle": "Olowooza kutandika? Kubuuzaganya naffe leero ku bwereere.",
  "svc.getQuote": "Nkuwe Bibuuzo",
  "svc.whatsapp": "Ganira ku WhatsApp",
  "svc.portfolioLabel": "Emirimu Gyaffe",
  "svc.testimonialsLabel": "Ebigambo by\'Abagagga",
  "svc.processLabel": "Ensalula Yaffe",
  "svc.pricingLabel": "Ebibuuzo by\'Omuwendo",
  "svc.basic": "Omusingi",
  "svc.standard": "Esandaada",
  "svc.premium": "Epirimiamu",
  "svc.popular": "Eyetuusibwako Ennyo",
  "svc.perMonth": "/ mwezi",
  "svc.oneTime": "kamwe",
  "svc.chooseplan": "Londa Engendera",

  "review.overview": "Ekyobirobero",
  "review.features": "Ebintu Ebikulukuta",
  "review.guide": "Endagiriro",
  "review.pricing": "Omuwendo",
  "review.verdict": "Ekigambo ky\'Omumalivu",
  "review.pros": "Eby\'amaanyi",
  "review.cons": "Ebikola obulabe",
  "review.tryAffiliate": "Gezaako Ku Bwereere",
  "review.getStarted": "Tandika ne",
  "review.bestFor": "Ekisinga Okukola",
  "review.ourRating": "Obukakafu Bwaffe",
  "review.freeTrialAvail": "Okulowoza Ku Bwereere",
  "review.yes": "Yee",

  "profile.title": "BientoMart",
  "profile.subtitle": "Omubenzi wo wa digital mu Uganda",
  "profile.aboutTitle": "Okunyiza/Amakula Katudde Digital",
  "profile.aboutP1": "BientoMart ye platformu eyokka ey'emyezo ya digital mu Uganda, essiga abantu n'abafumbo okwetonda obubonero obulungi mu Interent okuva mu 2020.",
  "profile.aboutP2": "Ekibiina kyaffe eky'abakugu mu kutondeka, marketing, n'AI kiragaako ekikolo okufuna obubonero obulungi eri abantu mu East Africa.",
  "profile.aboutP3": "Tukozesa tekinologiya ennungi n'okuwolfu emicweze y'ennyanjula mu Uganda okutondeka ebikolo bya digital ebinyonyola abantu mu Uganda.",
  "profile.cta": "Fika mu ifiini",
  "profile.valuesTitle": "Endagiro zaffe ez'ennyanjula",
  "profile.valuesSubtitle": "Ebikkammwa ebiyamba mu byonna oba tukola",
  "profile.teamTitle": "Meet Abaffe",
  "profile.teamSubtitle": "Abantu ab'obuntu abakola BientoMart",
  "profile.whyTitle": "Lwaki Ochule BientoMart",
  "profile.whySubtitle": "Kiki ekisengeka bintu mu bintu ebirala",
  "profile.why1Title": "Okutanga Obufiri",
  "profile.why1Desc": "Tufuna amakulu mu bigenda, buli edda. Tekirina kulema, tekirina ekigendererwa.",
  "profile.why2Title": "Okuwendo Obuli Mwangu",
  "profile.why2Desc": "Amawulire agatanirwa eri ebifunze bya Uganda n'enkozesa zabyo.",
  "profile.why3Title": "25/7 Ekusonyi",
  "profile.ty3Desc": "Ekusonyi okumala eddakiika kugatta ensonga yo teyandikkiriza.",
  "profile.ctaTitle": "Olina Okwetonda Emikolo Gyo?",
  "profile.ctaSubtitle": "Tukole ebintu ebiramu wamu. Fika mu ifiini lwa lweero okwetaba ku projekti yo",
  "profile.ctaButton": "Tanfika",
  "profile.callUs": "Tufone",

  "portfolio.title": "Ebikolwa Bwaffe",
  "portfolio.subtitle": "Laba ebikolwa baffe ebirongoze n'okulaba bwe tunaayamba ebifunze okufuna ebikole bya digital",
  "portfolio.projectsCompleted": "Ebikolwa Ebyakomekkedwa",
  "portfolio.happyClients": "Abantu Abasanyukira",
  "portfolio.yearsExperience": "Emyaka Gy'Obukugu",
  "portfolio.clientSatisfaction": "Okusanyukira Kw'Abantu",
  "portfolio.visitProject": "Laba Ekikolwa",
  "portfolio.industriesTitle": "T Industries Tukola Nayo",
  "portfolio.industriesSubtitle": "Obukugu bwaffe businga mu nsibuko ennungi, okutanga ebikole ebituukiriza buli ekikula",
  "portfolio.ctaTitle": "Olina Okwetonda Ekikolwa?",
  "portfolio.ctaSubtitle": "Tukole ebintu ebiramu wamu. Fika mu ifiini lwa lweero okwetaba ku projekti yo",
  "portfolio.startProject": "Tanfika Ekikolwa",
  "portfolio.viewServices": "Laba Ebikozesebwa",

  "nav.portfolio": "Ebikolwa",
};

export default lg;
